import PropTypes from 'prop-types'
import { Link as ReactRouterLink } from 'react-router-dom'
import styled from 'styled-components'

import colors from '../../../lib/Colors'
import withTracking from '../Tracking/WithTracking'

const StyledLink = styled(ReactRouterLink)`
  text-align: center;
  text-decoration: none;
  border-radius: 4px;
  min-width: ${(props) => {
    switch (props.width) {
      case 'mini':
        return '50px'
      case 'small':
        return '100px'
      case 'large':
        return '300px'
      case 'full':
        return '100%'
      case 'dynamic':
        return 'auto'
      case 'medium':
        return '150px'
      default:
        return props.width
    }
  }};
  ${(props) => {
    switch (props.size) {
      case 'mini':
        return `
          font-size: 12px;
          padding: .5em;`
      case 'small':
        return `
          font-size: 14px;
          padding: .5em;`
      case 'large':
        return `
          font-size: 18px;
          padding: 1em;`
      case 'medium':
      default:
        return `
          font-size: 16px;
          padding: 1em;`
    }
  }}
  cursor: ${(props) => {
    return props.loading ? 'default' : 'pointer'
  }};
  border: none;
  transition: ${(props) => {
      return ['text', 'nav'].includes(props.variation) ? 'color' : 'background'
    }}
    0.2s ease-in-out;
  color: ${(props) => {
    return props.variation === 'text' ? colors.brand_primary : colors.white
  }};
  background: ${(props) => {
    switch (props.variation) {
      case 'primary':
        return colors.brand_primary
      case 'info':
        return colors.brand_info
      case 'success':
        return colors.brand_success
      case 'warning':
        return colors.brand_warning
      case 'danger':
        return colors.brand_danger
      case 'text':
      default:
        return 'none'
    }
  }};
  &:hover {
    color: ${(props) => {
      return props.variation === 'text' ? colors.brand_primary_hover : null
    }};
    background: ${(props) => {
      switch (props.variation) {
        case 'primary':
          return colors.brand_primary_hover
        case 'info':
          return colors.brand_info_hover
        case 'success':
          return colors.brand_success_hover
        case 'warning':
          return colors.brand_warning_hover
        case 'danger':
          return colors.brand_danger_hover
        case 'text':
        default:
          return null
      }
    }};
  }
  &:active {
    outline: none;
  }
  &:disabled {
    cursor: not-allowed;
    color: ${(props) => {
      return props.variation === 'text' ? colors.gray_light : null
    }};
    background: ${(props) => {
      switch (props.variation) {
        case 'primary':
          return colors.brand_primary_disabled
        case 'info':
          return colors.brand_info_disabled
        case 'success':
          return colors.brand_success_disabled
        case 'warning':
          return colors.brand_warning_disabled
        case 'danger':
          return colors.brand_danger_disabled
        case 'text':
        default:
          return null
      }
    }};
  }
`

const Link = (props) => {
  const { children, onClick, track, ...rest } = props
  const handleClick = (...args) => {
    track()
    if (typeof onClick === 'function') {
      onClick(...args)
    }
  }
  return (
    <StyledLink onClick={handleClick} {...rest}>
      {children}
    </StyledLink>
  )
}

Link.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.element,
    PropTypes.string,
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['mini', 'small', 'medium', 'large']),
  to: PropTypes.string,
  track: PropTypes.func,
  variation: PropTypes.oneOf([
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    'text',
    'nav',
  ]),
  width: PropTypes.oneOf([
    'mini',
    'small',
    'medium',
    'large',
    'dynamic',
    'full',
  ]),
}

Link.defaultProps = {
  to: '/',
  variation: 'text',
  size: 'medium',
  width: 'dynamic',
}

export default withTracking()(Link)
